<div>
	<div class="sidebar-top">
		<button (mouseover)="onBurgerHover()">
			<span></span>
		</button>
	</div>

	<div class="sidebar-sections">
		<mat-accordion displayMode="flat" [multi]="false">
			<ng-container *ngFor="let section of sections">
				<ng-container *ngIf="!(section.hideAtPresentMode && (presenterMode.applyIncognito | async))">
					<ng-container *ngFor="let chapter of section.chapters">
						<ng-container *ngIf="chapter.isAllowed">
							<ng-container *ngIf="chapter.type === sectionChapterEnum.Link; else chapterList">
								<div routerLinkActive="active" [routerLink]="chapter.url">{{ chapter.name }}</div>
							</ng-container>

							<ng-template #chapterList>
								<mat-expansion-panel [expanded]="section.isExpanded" [hideToggle]="isCollapsed">
									<mat-expansion-panel-header>
										<span [class.active]="section.name === currentSection?.name" data-test-id="sidebar-chapter">
											<span
												[class.activeIcon]="section.name === currentSection?.name"
												class="sidebar-icon"
												routerLinkActive="activeIcon"
												[innerHTML]="sanitizeSvg(chapter.iconUrl)"
											>
											</span>
											<span
												class="side-section-title"
												[attr.data-test-id]="chapter?.name?.replace(' ', '-').toLowerCase()"
												>{{ chapter.name }}</span
											>
										</span>
									</mat-expansion-panel-header>

									<ng-template matExpansionPanelContent>
										<ul>
											<ng-container *ngFor="let link of chapter.pages">
												<!--@Todo: remove with ZES-10479-->
												<li
													*ngIf="
														link.isAllowed &&
														(link.name !== 'Access Tokens' ||
															(link.name === 'Access Tokens' && enableContainersPodRecommendation)) &&
														(link.name !== 'Kubernetes' || (link.name === 'Kubernetes' && enableOptimizationHub)) &&
														link.name !== 'Database Explorer' &&
														(link.name !== 'Approve Billing' ||
															(link.name === 'Approve Billing' && enableApproveBilling))
													"
													class="d-flex align-items-center"
													[routerLink]="link.url"
													routerLinkActive="active"
												>
													<span class="sidebar-icon" [innerHTML]="sanitizeSvg(link.iconUrl)"></span>
													<span class="side-section-sub-title">{{ link.name }}</span>
													<span class="side-section-sub-title-badge ml-2" *ngIf="link.badge">{{ link.badge }}</span>
												</li>
											</ng-container>
											<ng-container *ngIf="section.name === PARTNER_PORTAL && isPartnerSupportForm">
												<li (click)="openSupportModal()">
													<span class="sidebar-icon" [innerHTML]="sanitizeSvg(supportIcon)"> </span>
													<span class="sidebar-icon ml-2">Support</span>
												</li>
											</ng-container>
										</ul>
									</ng-template>
								</mat-expansion-panel>
							</ng-template>
						</ng-container>
					</ng-container>
				</ng-container>
			</ng-container>
		</mat-accordion>
	</div>
</div>

<div>
	<div
		class="sidebar-add-account"
		*ngIf="isAddAccountAllowed"
		(click)="onAddAccountClicked()"
		data-test-id="add-account-button"
	>
		Add Account
	</div>

	<div
		[routerLink]="appRouteHelper.audit"
		routerLinkActive="active"
		data-test-id="audit-log-btn"
		*ngIf="isAuditLogAllowed"
	>
		<img src="/assets/icons/sidebar-audit-log-icon.png" alt="Audit Log Icon" />
		<span data-test-id="audit-log">Audit Log</span>
	</div>
	<ng-container *ngIf="isSupportAndDocsBtnsVisible && !isPartnerSupportForm">
		<div
			class="zesty-support wrapper d-flex align-items-center"
			data-test-id="support-form-zesty"
			(click)="openSupportModal()"
		>
			<span class="zesty-support__svg" style="display: block" [innerHTML]="sanitizeSvg(supportIcon)"></span>
			<span class="zesty-support__btn_txt">Support</span>
		</div>

		<div *ngIf="!enableCommunityPortal; else communityPortal" (click)="openDocumentation()">
			<img src="/assets/icons/view-file_white.svg" alt="Documentation Icon" />
			<span>Documentation</span>
		</div>

		<ng-template #communityPortal>
			<div (click)="openCommunityPortal()">
				<img src="/assets/icons/view-file_white.svg" alt="Community Portal Icon" />
				<span>Community Portal</span>
			</div>
		</ng-template>
	</ng-container>
</div>
<div class="d-flex justify-content-end toggle-wrapper" (click)="toggle()">
	<img
		height="16"
		width="11"
		class="d-block ml-1"
		[@rotateArrow]="isCollapsed"
		src="/assets/icons/sidebar-arrow.png"
		alt="Arrow"
	/>
</div>
